export default "__VITE_ASSET__Tv_nbMC2__"